import React from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import FloatingChatButton from "../components/FloatingChatButton";
import { useRef, useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import SwiperCore from "swiper";
import { FreeMode, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";

SwiperCore.use([FreeMode, Autoplay]);

const About = () => (
  <div className="bg-white min-h-screen pt-10 pb-20">
    <Header />
    <div className="container mx-auto px-4">
      <h1 className="text-5xl font-bold text-center mb-8 font-montserrat">
        <span className="text-[#1976f2]">About</span> Us
      </h1>
      <div className="max-w-3xl mx-auto text-lg text-gray-800 mb-12 text-center">
        <p className="mb-8 font-open-sans">
          Medical Linkers is a leading medical tourism facilitating company with
          long-standing associations with well-known hospitals and clinics all
          over the world. That's not the only thing that's making us the best in
          the industry. Our services are rooted in empathy, we value
          professionalism in our endeavors and believe that reliability is the
          keystone of our work. This is how we operate. The rest is just
          details.
        </p>
        <div className="flex justify-center mb-12">
          <img
            src="/images/aboutus-mainbanner.png"
            alt="Award Ceremony"
            className="rounded-lg shadow-lg  w-full"
          />
        </div>
        <p className="mb-4 font-open-sans">
          We understand that medical procedures, notwithstanding how big or
          small, can be daunting for patients and their caregivers. Medical
          Linkers is committed to giving patients the highest class of care
          possible by maintaining our standards of service excellence.
        </p>
        <p className="font-open-sans">
          We know that 'time' is of the essence where treatments and procedures
          are concerned which is why we offer holistic and comprehensive medical
          solutions under one umbrella of services.
        </p>
      </div>
      {/* The Team Section */}
      <div className="mt-20">
        <h2 className="text-4xl font-bold text-center mb-8 font-montserrat">
          <span className="text-[#1976f2]">The</span> Team
        </h2>
        <div className="flex flex-col md:flex-row items-center justify-center gap-12 mb-8">
          <img
            src="/images/sonam-sharma.webp"
            alt="Team Member 1"
            className="w-48 h-56 object-cover rounded-lg shadow"
          />
          <img
            src="/images/amit-sharma.webp"
            alt="Team Member 2"
            className="w-48 h-56 object-cover rounded-lg shadow"
          />
        </div>
        <div className="max-w-2xl mx-auto text-lg text-gray-800 text-center">
          <p className="font-open-sans">
            We connect our patients with top-notch hospitals and doctors through
            the personal equation that we have with them. This enables our
            clients to get the best of the attention through a fast-tracked
            process. Our database is very extensive, meticulous and thorough and
            only the best of the best, find a place there. This means, our
            customers have an exclusive entry with the right specialist,
            surgeon, hospitals, and clinics at the right time.
          </p>
        </div>
      </div>
      {/* About Stats Section (Live Counter) */}
      <AboutStats />
      {/* Satisfied Patients Section */}
      <section className="py-16 bg-[#f9f9f9]">
        <div className="container mx-auto px-4">
          <h3 className="text-4xl font-bold mb-8 text-center font-montserrat">
            <span className="text-[#1976f2]">Satisfied</span> Patients
          </h3>

          <Swiper
            slidesPerView={3}
            spaceBetween={24}
            loop={true}
            freeMode={true}
            autoplay={{ delay: 0, disableOnInteraction: false }}
            speed={3000}
            grabCursor={true}
            className="w-full"
          >
            {[...patients, ...patients].map((img, index) => (
              <SwiperSlide key={index}>
                <div className="h-[400px] rounded-xl overflow-hidden shadow-lg bg-white">
                  <img
                    src={img}
                    alt={`Patient ${index + 1}`}
                    className="w-full h-full object-cover"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
      {/* Contact Us Button Section */}
      <div className="flex justify-center mb-12">
        <Link
          to="/contactus"
          className="bg-[#1976f2] text-white px-8 py-3 rounded-full text-lg font-semibold shadow hover:bg-blue-600 transition"
        >
          Contact Us
        </Link>
      </div>
    </div>
    <Footer />
    <FloatingChatButton />
  </div>
);

export default About;

function useCountUpOnView(target, duration = 1200, trigger) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!trigger) return;
    setCount(0);
    let start = 0;
    const increment = Math.ceil(target / (duration / 16));
    const interval = setInterval(() => {
      start += increment;
      if (start >= target) {
        setCount(target);
        clearInterval(interval);
      } else {
        setCount(start);
      }
    }, 16);
    return () => clearInterval(interval);
  }, [target, duration, trigger]);
  return count.toLocaleString();
}

function AboutStats() {
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      { threshold: 0.5 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  // You can change these images and names as needed
  const treatedPatients = useCountUpOnView(25000, 1200, inView);
  const treatments = useCountUpOnView(250, 1200, inView);
  const hospitals = useCountUpOnView(250, 1200, inView);
  const doctors = useCountUpOnView(500, 1200, inView);

  return (
    <div ref={sectionRef} className="bg-blue-50 py-16 mt-16 rounded-lg">
      <div className="container mx-auto grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="flex flex-col items-center">
          <div className="bg-white rounded-lg p-4 mb-4">
            <img
              src="/images/image copy 67.png"
              alt="Treated Patients"
              className="w-12 h-12 object-contain"
            />
          </div>
          <div className="text-3xl font-bold">{treatedPatients}</div>
          <div className="text-lg text-gray-700">Treated Patients</div>
        </div>
        <div className="flex flex-col items-center">
          <div className="bg-white rounded-lg p-4 mb-4">
            <img
              src="/images/image copy 69.png"
              alt="Treatments"
              className="w-12 h-12 object-contain"
            />
          </div>
          <div className="text-3xl font-bold">{treatments}</div>
          <div className="text-lg text-gray-700">Treatments</div>
        </div>
        <div className="flex flex-col items-center">
          <div className="bg-white rounded-lg p-4 mb-4">
            <img
              src="/images/image copy 67.png"
              alt="Hospitals"
              className="w-12 h-12 object-contain"
            />
          </div>
          <div className="text-3xl font-bold">{hospitals}</div>
          <div className="text-lg text-gray-700">Hospitals</div>
        </div>
        <div className="flex flex-col items-center">
          <div className="bg-white rounded-lg p-4 mb-4">
            <img
              src="/images/image copy 68.png"
              alt="Doctors"
              className="w-12 h-12 object-contain"
            />
          </div>
          <div className="text-3xl font-bold">{doctors}</div>
          <div className="text-lg text-gray-700">Doctors</div>
        </div>
      </div>
    </div>
  );
}

const patients = [
  "/images/satisfied-p1.png",
  "/images/satisfied-p2.png",
  "/images/satisfied-p3.png",
];
